import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NglModule } from 'ng-lightning';
import { RouterModule } from '@angular/router';

import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { ModalConfirmComponent } from './components/modal-confirm/modal-confirm.component';
import { NullStateComponent } from './components/null-state/null-state.component';
import { TopBannerBroadcastComponent } from './components/top-banner-broadcast/top-banner-broadcast.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { HttpLoaderFactory } from '../app.httpLoaderFactory';
import { ToastComponent } from './components/toast/toast.component';

@NgModule({
  declarations: [
    BreadcrumbComponent,
    NavbarComponent,
    ModalConfirmComponent,
    NullStateComponent,
    TopBannerBroadcastComponent,
    ToastComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    NglModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
      isolate: false,
    }),
  ],
  exports: [
    BreadcrumbComponent,
    NavbarComponent,
    ModalConfirmComponent,
    NullStateComponent,
    TopBannerBroadcastComponent,
    TranslateModule,
    ToastComponent,
  ],
})
export class SharedModule {}
